import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import {
  fetchCompareDeliveries,
  type CompareDeliveriesFilters,
} from '../services/compare-deliveries.service'

export {
  type CompareDeliveriesRow,
  type CompareDeliveriesFilters,
} from '../services/compare-deliveries.service'

export function injectCompareDeliveriesQuery(
  filters: Signal<CompareDeliveriesFilters>,
) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => {
    const f = filters()
    return {
      queryKey: ['compare-deliveries', f],
      queryFn: async ({ signal }) => {
        return fetchCompareDeliveries(cartoClient, f, signal)
      },
      enabled:
        f.delivery_id_1 > 0 &&
        f.delivery_id_2 > 0 &&
        !!f.delivery_start_date_1 &&
        !!f.delivery_start_date_2,
    }
  })
}
